import { useState } from 'react';
import { Download, Share, SquarePlus } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { useInstallPrompt } from '../lib/pwa';
import { useAppVersion } from '../version';
import { useAuth } from '../context/AuthContext';
import { ReleaseNotesDialog } from './ReleaseNotes';

const BADGE = 'rounded-md bg-orange-50 px-1.5 py-0.5 align-middle text-[11px] font-semibold text-orange-600 ring-1 ring-orange-200';

// Süper Admin'de tıklanabilir (sürüm notları), diğer kullanıcılarda yalnız etiket
export const VersionBadge = ({ testId = 'app-version' }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { version: APP_VERSION, date } = useAppVersion();
  if (!user?.is_super_admin) return <span className={BADGE} data-testid={testId}>{APP_VERSION}</span>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} title={`Sürüm notları${date ? ` · Yayın: ${date.split('-').reverse().join('.')}` : ''}`} className={`${BADGE} cursor-pointer transition-colors hover:bg-orange-100`} data-testid={testId}>{APP_VERSION}</button>
      <ReleaseNotesDialog open={open} onOpenChange={setOpen} />
    </>
  );
};

export const PwaInstallButton = () => {
  const { canPrompt, iosHint, install } = useInstallPrompt();
  const [open, setOpen] = useState(false);
  if (!canPrompt && !iosHint) return null;
  return (
    <>
      <button type="button" onClick={() => (canPrompt ? install() : setOpen(true))}
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-orange-600"
        data-testid="pwa-install-btn">
        <Download className="h-4 w-4" /> Uygulamayı Yükle
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="pwa-ios-hint-dialog">
          <DialogHeader>
            <DialogTitle>Ana Ekrana Ekle</DialogTitle>
            <DialogDescription>İSG Permit'i iPhone / iPad ana ekranınıza uygulama olarak ekleyin.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm text-slate-700">
            <li className="flex items-center gap-2"><Share className="h-4 w-4 text-blue-600" /> Safari'de alttaki <b>Paylaş</b> simgesine dokunun.</li>
            <li className="flex items-center gap-2"><SquarePlus className="h-4 w-4 text-slate-700" /> <b>Ana Ekrana Ekle</b> seçeneğini seçin.</li>
            <li className="flex items-center gap-2"><Download className="h-4 w-4 text-orange-500" /> Sağ üstteki <b>Ekle</b> ile onaylayın.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
